import {
  Alert,
  AlertIcon,
  CloseButton,
  Flex,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

const AlertInvalidBet = () => {
  const gameConfig = useSelector((state) => state.isGameConfig);

  const { onOpen, onClose, isOpen: isVisible } = useDisclosure();

  const { is_invalid_bet } = gameConfig;

  useEffect(() => {
    if (is_invalid_bet === 1) {
      onOpen();
    }
  }, [is_invalid_bet, onOpen]);

  if (is_invalid_bet === 0) {
    return null;
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.95 }}
          transition={{
            duration: 0.3,
            ease: "easeInOut",
          }}
        >
          <Alert
            justifyContent={"space-between"}
            borderRadius={3}
            status="warning"
            variant={"solid"}
          >
            <Flex>
              <AlertIcon />
              <Text>此款遊戲為無效投注，不計入流水</Text>
            </Flex>
            <CloseButton alignSelf="flex-start" onClick={onClose} />
          </Alert>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AlertInvalidBet;
